module.exports = __webpack_public_path__ + "img/img2.df955dae.svg";